import { render, staticRenderFns } from "./Accomodation.vue?vue&type=template&id=258fd08e&scoped=true"
import script from "./Accomodation.vue?vue&type=script&lang=js"
export * from "./Accomodation.vue?vue&type=script&lang=js"
import style0 from "./Accomodation.vue?vue&type=style&index=0&id=258fd08e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258fd08e",
  null
  
)

export default component.exports